"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSha256Hash = void 0;
const getSha256Hash = async (message) => {
    try {
        // https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/digest#converting_a_digest_to_a_hex_string
        const msgUint8 = new TextEncoder().encode(message);
        const hashBuffer = await window.crypto.subtle.digest("SHA-256", msgUint8);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const hashHex = hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
        return hashHex;
    }
    catch (_a) {
        return message;
    }
};
exports.getSha256Hash = getSha256Hash;
